import NumberSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/NumberSetting';
import Typography from 'hb-builder/components/common/SettingsLibrary/ComposedInputs/Typography';
import InputTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/InputTitle';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import type { ButtonItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/buttonItemAttributes';

const ButtonTypography = ({
  defaultAttributes,
  item,
  numberButtons,
  onChange,
}: ComponentSettingsTab<ButtonItemAttributes> & {
  numberButtons: number;
}) => {
  const hasMultipleButtons = numberButtons > 1;

  const settingProps = {
    defaultAttributes,
    item,
    onChange,
  };

  return (
    <>
      <InputTitle boxProps={{ mb: 4 }} label={__('Text')} />
      <Typography
        componentType="button"
        includeFontFamily={!hasMultipleButtons}
        includeFontSize={!hasMultipleButtons}
        includeLineHeight={false}
        {...settingProps}
      />
      {!hasMultipleButtons && (
        <NumberSetting
          settingKey="buttonLetterSpacing"
          title={__('Character spacing')}
          {...settingProps}
        />
      )}
    </>
  );
};

export default ButtonTypography;
